export default __webpack_public_path__ + "static/media/quiz.aa47bdc5.svg";